function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP store
 * 
 */
import React from 'react';
import './ClubStore.scss';
import { deliveryPickUpStore } from '../../actions';
import { connect } from 'react-redux';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export class ClubStore extends React.Component {
  constructor(props) {
    super(props);
    /**
     * onFocus
     */
    _defineProperty(this, "onFocus", focus => {
      const {
        setDeliveryPickUpStore
      } = this.props;
      setDeliveryPickUpStore(focus);
      this.setState({
        focus
      });
    });
    /**
     * onBlur
     */
    _defineProperty(this, "onBlur", () => {
      this.setState({
        focus: ''
      });
    });
    /**
     * Select the club store
     * @param value
     */
    _defineProperty(this, "select", value => {
      const {
        setDeliveryPickUpStore
      } = this.props;
      setDeliveryPickUpStore(value);
    });
    this.handleClick = this.handleClick.bind(this);
    this.state = {
      showOpeningHours: false
    };
  }
  handleClick() {
    this.setState(() => ({
      showOpeningHours: !this.state.showOpeningHours
    }));
  }
  render() {
    const {
      clubStore,
      deliveryPickUpStore
    } = this.props;
    const checked = clubStore.id === deliveryPickUpStore.value;
    const highlight = checked ? ' highlight' : '';
    return /*#__PURE__*/_jsxs("div", {
      className: "radiobutton-container ClubStore",
      tabIndex: "0",
      onBlur: () => this.onBlur,
      onFocus: () => this.onFocus(clubStore.id),
      children: [/*#__PURE__*/_jsx("input", {
        id: `clubStore-${clubStore.id}`,
        className: "radio-button-hidden",
        type: "radio",
        checked: checked,
        value: clubStore.id,
        onChange: () => this.select(clubStore.id)
      }), /*#__PURE__*/_jsxs("label", {
        htmlFor: `clubStore-${clubStore.id}`,
        children: [/*#__PURE__*/_jsx("div", {
          className: "radio-display",
          children: /*#__PURE__*/_jsx("div", {
            className: `inner${highlight}`
          })
        }), clubStore.name]
      }), /*#__PURE__*/_jsxs("p", {
        children: [clubStore.address_1, /*#__PURE__*/_jsx("br", {}), clubStore.address_2 && /*#__PURE__*/_jsxs(_Fragment, {
          children: [clubStore.address_2, /*#__PURE__*/_jsx("br", {})]
        }), clubStore.address_suburb, ", ", clubStore.address_state]
      }), /*#__PURE__*/_jsxs("div", {
        className: "opening-hours",
        children: [/*#__PURE__*/_jsx("span", {
          onClick: () => this.handleClick(),
          className: this.state.showOpeningHours ? 'open' : null,
          children: "Opening hours"
        }), this.state.showOpeningHours ? /*#__PURE__*/_jsx("p", {
          children: clubStore.opening_hours
        }) : null]
      })]
    }, clubStore.id);
  }
}
_defineProperty(ClubStore, "defaultProps", {
  application: {
    club: {
      id: ''
    }
  },
  deliveryPickUpStore: 0
});
const mapStateToProps = ({
  application,
  deliveryPickUpStore
}) => {
  return {
    application,
    deliveryPickUpStore
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setDeliveryPickUpStore: value => {
      dispatch(deliveryPickUpStore(value));
    }
  };
};
const VisibleClubStore = connect(mapStateToProps, mapDispatchToProps)(ClubStore);
export default VisibleClubStore;